import React from "react";
import AddIcon from "@mui/icons-material/Add";
import Controls from "src/components/form/controls/Controls";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import ShowCacheFLFDevice from "../ShowCache/ShowCacheFLFDevice";
import { allowedToCreateEntity } from "src/constants/role";
import useAuth from "src/hooks/useAuth";
import { path } from "src/constants/path";
import { Link } from "react-router-dom";
import { CACHE_DEVICE } from "src/constants/actionCache";

const FLFDeviceControlPanel = ({
  children,
  isSorted,
  handleSort,
  currentActionCache,
  permissionsAccessControl,
  page,
  categoryId,
}) => {
  const { auth } = useAuth();
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Device"
          isShowButton={isShowCache(currentActionCache, CACHE_DEVICE)}
        >
          <ShowCacheFLFDevice
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>
        {isSorted ? (
          <Controls.Button
            text="Apply sort"
            variant="outlined"
            onClick={handleSort}
          />
        ) : null}

        {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
          <Link
            to={{
              pathname: `${path.flfDevice}/add`,
              state: { page: page, categoryId: categoryId },
            }}
          >
            <Controls.Button
              text="Add New"
              variant="outlined"
              startIcon={<AddIcon />}
            />
          </Link>
        )}
      </div>
    </div>
  );
};

export default FLFDeviceControlPanel;
